import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function AuthCallback() {
  const { source, ready } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (ready && source) nav('/', { replace: true });
    else if (ready && !source) nav('/login', { replace: true });
  }, [ready, source, nav]);

  if (!ready) return <div style={{ padding: 32 }}>Signing you in…</div>;
  if (source) return <Navigate to="/" replace />;
  return <Navigate to="/login" replace />;
}
